function crShowColorVariants(root = document) {
  root.querySelectorAll('#main .product-item .product-variant').forEach((opt) => {
    const name = opt.getAttribute('data-name') || ''

    if (name.includes('color')) {
      opt.setAttribute('visible', '')
    }
  })
}

crShowColorVariants()

document.addEventListener('shopify:section:load', (event) => {
  crShowColorVariants(event.target)
})

const crVariantObserver = new MutationObserver(() => {
  crShowColorVariants()
})

const main = document.querySelector('#main')

if (main) {
  crVariantObserver.observe(main, {
    childList: true,
    subtree: true
  })
}